/*
 * Pedidos extras que têm plano B próprio: os vídeos pelo Player AWS da
 * resolução, do tema de redação e dos modais "Como funciona" (sem eles, toca o
 * Vimeo) e os exercícios ligados à aula (sem eles, a aba usa só a matéria). Um
 * 401 deles — tela sem login da plataforma, como o gabarito do ENEM 365, ou
 * sessão vencida — não pode mandar o aluno para /logout no meio do exercício.
 */
const OPTIONAL_AUTH_PATHS = [
  '/exercises/resolution-video/',
  '/essaythemes/videos/',
  '/modal-videos/',
  '/linked-exercises',
];

export const isOptionalAuthRequest = (url = ''): boolean =>
  OPTIONAL_AUTH_PATHS.some((path) => url.includes(path));
